import React from 'react'

import Offer from './Offer'

import Carousel from '../../subcomponents/Carousel'
import ViewToggle from '../../subcomponents/ViewToggle'
import { FootnotesFromContext } from "../../subcomponents/Footnotes";

const OfferPromo = props => {
    const carouselProps = {
        headline: props.carouselHeadline,
        lang: props.lang
    }

    if (props.isMobile('web')) {
        carouselProps.more = ''
    }

    return (
        <ViewToggle isMobile={props.isMobile('web')}>
            <Carousel {...carouselProps}>
                <Offer className="promo" {...props} campaign={props.campaign} />
            </Carousel>
            <FootnotesFromContext
                showWarningText={props.footnotesWarningText}
                bigIndices={props.bigIndices}
            />
        </ViewToggle>
    )
}

export default OfferPromo



// WEBPACK FOOTER //
// ./src/components/ads/mam3/OfferPromo.js